import { render, staticRenderFns } from "./OperatingHours.vue?vue&type=template&id=8de06ac2&"
import script from "./OperatingHours.vue?vue&type=script&lang=ts&"
export * from "./OperatingHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports